
import { CustomImage, TextCustom, ButtonCustomLink, ButtonAppearance, buttonPaddingGenerator, DisableFocusWrapper } from '@vw-marketing/us-components'
import { LayerCloseHandleV2 } from '@volkswagen-onehub/layer-manager'
import React from 'react'
import { RedirectLayerState } from '../../typing/modal-display'
import { AppConstants } from '../../utils/app-constants'
import { redirectTitleTextStyle, redirectDescriptionTextStyle, redirectCloseTextStyle } from './helpers'
import { StyledModalRedirectContainer, StyledTitleWithLogo, StyledModalRedirectImage, StyledModalRedirectTitle, StyledModalRedirectDescription, StyledModalRedirectButton } from './styles'

const ModalRenderContent = (state: RedirectLayerState,
    close: LayerCloseHandleV2<void>
    // ,options: LayerRenderOptionsV2 // NOTE: Just for information about layers
    ) => {
  const {translations, urlRedirect, onCloseHandler} = state;

  const onHandleInternalClose = () => {
    close && close();
    onCloseHandler && onCloseHandler();
  }
  return (
    <StyledModalRedirectContainer
    className="modal-redirect-container"
    // extraPadding={largeTitlePadding}
  >
    <StyledTitleWithLogo
      hasDescription={translations?.description}
      className="title-with-logo"
    >
      <StyledModalRedirectImage className="modal-redirect-image">
        <CustomImage
          src={AppConstants.Ngw6Logo44x42}
          alt={AppConstants.Ngw6Logo44x42}
          srcPlaceholder={AppConstants.Ngw6Logo44x42}
          srcErrorImage={AppConstants.NoFoundImageError348x196}
        />
      </StyledModalRedirectImage>
      <StyledModalRedirectTitle className="modal-redirect-title">
        <TextCustom {...redirectTitleTextStyle}>
          {translations?.title}
        </TextCustom>
      </StyledModalRedirectTitle>
    </StyledTitleWithLogo>
    {translations?.description && (
      <StyledModalRedirectDescription className="modal-redirect-description">
        <TextCustom {...redirectDescriptionTextStyle}>
          {translations.description}
        </TextCustom>
      </StyledModalRedirectDescription>
    )}
    <DisableFocusWrapper>
    <StyledModalRedirectButton className="modal-redirect-button">
      <ButtonCustomLink
        href={urlRedirect || ''}
        appearance={ButtonAppearance.Primary}
        onClick={onHandleInternalClose}
        stretchContent
        target={'_blank'}
        padding={buttonPaddingGenerator(12, 40)}
      >
        <TextCustom {...redirectCloseTextStyle}>
          {translations?.closeCtaLabel}
        </TextCustom>
      </ButtonCustomLink>
    </StyledModalRedirectButton>
    </DisableFocusWrapper>
  </StyledModalRedirectContainer>
  )
}

export default ModalRenderContent
